var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasResults)?_c('div',[(_vm.value || _vm.value === 0)?_c('span',[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]):_c('span',{staticClass:"text-muted"},[_vm._v("—")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }